<template>
    <section class="section">
        <vue-headful
            title="Select Line  - Home"
        />
        <h2>{{ $t ("select-line") }}</h2>
        <div class="container columns">
            <div class="column is-one-fifth">
                <b-select
                    v-model="line"
                    @input="changeFilter"
                >
                    <option
                        v-for="line in lines"
                        :value="line [0]"
                        :key="line [0].toString ()">
                        {{ line [1] }}
                    </option>
                </b-select>
            </div>
            <div class="column">
                <b-button type="is-primary" :loading="loading" @click="setLineAndShop"
                >{{ $t ("to-shop") }}</b-button>
            </div>
            <!--
            <div class="column">
                <b-button type="is-link" :loading="loading" @click="getMatOverview('PDF')"
                >{{ $t ("get-material-pdf") }}</b-button>
            </div>
            <div class="column">
                <b-button type="is-link" :loading="loading" @click="getMatOverview('XLS')"
                >{{ $t ("get-material-xls") }}</b-button>
            </div>
            -->
        </div>
        <p>&nbsp;</p>
        <h2>{{ $t ("materials-list-header") }}</h2>
        <b-table
            :data="materials2line"
            :debounce-search="100"
            :loading="loadMaterial2Line"
            paginated
            ref="matList"
            >
            <b-table-column field="material" label="Material" sortable searchable v-slot="props">
                {{ props.row.material }}
            </b-table-column>
            <b-table-column field="prodname" label="Herstellername" sortable searchable v-slot="props">
                {{ props.row.prodname }}
            </b-table-column>
            <b-table-column field="line__name" label="Produktions Line" sortable searchable>
                <template
                    slot="searchable"
                    slot-scope="props">
                    <b-select placeholder="Filter by line..."
                        v-model="props.filters[props.column.field]"
                        icon="search-plus"
                        @input="changeLineSelection"
                    >
                        <option value="" key="all">---</option>
                        <option
                            v-for="l in lines"
                            :value="l [1]"
                            :key="l [0].toString ()"
                            >
                            {{ l [1] }}
                        </option>
                    </b-select>
                </template>
                <template v-slot="props">
                    {{ props.row.line__name }}
                </template>
            </b-table-column>
            <b-table-column field="thicknesses" label="Dicken" v-slot="props">
                {{ thicknessDisplay (props.row.thicknesses) }}
            </b-table-column>
            <b-table-column field="texture" label="Bild" v-slot="props">
                <img :src="materialImage(props.row.texture)" class="small-image"
                  @mouseover="previewPk = props.row.pk"
                  @mouseleave="previewPk = -1"
                />
                <img :src="materialImage(props.row.texture)"
                    class="big-image"
                    :id="textureId (props.row.pk)"
                    v-show="previewPk == props.row.pk"
                  @click="hideBigImage (props.row.pk)"
                />

            </b-table-column>
        </b-table>
    </section>
</template>

<script>
import axios from "axios"
import { mapGetters } from 'vuex'

export default {
    name: "SelectLine",
    data () {
        return {
            lines: this.$store.state.user.user.lines.lines,
            line:  this.$store.state.user.user.lines.active,
            loading: false,
            loadMaterial2Line: true,
            materials2line: [],
            mat2LineColumns: [
            { field: "material"
                , label: "Material"
                , sortable: true
                , searchable: true
                },
                { field: "prodname"
                , label: "Herstellername"
                , sortable: true
                , searchable: true
                },
                { field: "line__name"
                , label: "Linie"
                , sortable: true
                , searchable: true
                },
                { field: "thicknesses"
                , label: "Dicken"
                , sortable: true
                , searchable: true
                }
            ],
            previewPk: -1
            }
    },
    computed: {
        ...mapGetters(["getUserToken", "getCompany"]),
    },
    methods: {
        setLineAndShop() {
            this.loading = true
            const cid = this.getCompany
            axios.post (
                "/vue/change-line-and-shop/",
                { line: this.line, cid: cid},
                { headers: { Authorization: "Token " + this.getUserToken}}
            ).then ((response) => {
                if (response.data.status) {
                    this.$buefy.toast.open ({
                        message: this.$i18n.t("Redirect to shop"),
                        type: 'is-info',
                        duration: 1000,
                        })
                    this.$store.dispatch ("shopClicked", cid)
                }
            })
        },
        getMatOverview(kind) {
            window.open(`/vue/material-overview/${kind}/`, '_blank').focus()
        },
        reloadMaterials2Line () {
            this.loadMaterial2Line = true
            const cid = this.getCompany
            axios.get (
                `/vue/company/${cid}/material-list/`,
                { headers: { Authorization: "Token " + this.getUserToken}}
            ).then ((response) => {
                if (response.data.status) {
                    this.materials2line = response.data.data.materials2line
                } else {
                    this.$buefy.toast.open ({
                        message: "Error loading materials",
                        type: 'is-error',
                        duration: 1000,
                        })
                }
                this.loadMaterial2Line = false
                this.changeFilter (this.line)
            })
        },
        thicknessDisplay (thicknesses) {
            let result = thicknesses.split ("|").map ((t) => parseInt (t))
            return result.sort ((a, b) => a-b).join (", ")
        },
        changeFilter(x) {
            const lineName = this.lines.filter (lo => lo [0] == x) [0] [1]
            if (lineName) {
                this.$set (this.$refs.matList.filters, "line__name", lineName)
            }
        },
        changeLineSelection(newLine) {
            const lineId = this.lines.filter (lo => lo [1] == newLine) [0] [0]
            if (lineId !== undefined) {
                this.line = lineId
            }
        },
        materialImage (image) {
            return `https://shop.designbox.solutions/fileadmin/imosnet/2138/image/${image}`
        },
        textureId(pk) {
            return `textureImage${pk}`
        },
    },
    mounted () {
        this.reloadMaterials2Line ()
    }
}
</script>

<style>
    .big-image {
        position: fixed;
        max-width: 256px;
        left: 40%;
        top: 40%;
        border: 4px solid #a72523 ;
        border-radius: 50%;
        z-index: 1000;
    }
    .small-image {
        border-radius: 50%;
        height: 2em;
        border: 1px solid #a72523 ;
    }
</style>
